import React from "react";

// Logo concept D — "Cut monogram": accent tile, bold white U, ink bar across the middle.
export function UndrMark({ size = 28, accent = "var(--accent)", title }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 76 76"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : "true"}
      aria-label={title}
    >
      <rect width="76" height="76" rx="18" fill={accent} />
      <path d="M18 14v26a20 20 0 0 0 40 0V14" fill="none" stroke="#FFFFFF" strokeWidth="10" strokeLinecap="round" />
      <rect x="10" y="37" width="56" height="7" rx="3.5" fill="#1B1B18" />
    </svg>
  );
}

export function UndrWordmark({ size = 22, color = "inherit", style }) {
  return (
    <span
      style={{
        fontFamily: "'Space Grotesk', sans-serif",
        fontWeight: 700,
        fontSize: size,
        letterSpacing: -0.5,
        lineHeight: 1,
        color,
        ...style,
      }}
    >
      undr
    </span>
  );
}

export default UndrMark;
